import React, { useState } from "react";
import style from "./CustomSelect.module.css"

interface CustomSelectProps {
  optionList: any[];
  setCompanySelected: any;
  getOptionList: any;
  label: string
  companySelected?: string
  companyId?: string
}
export const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  optionList,
  setCompanySelected,
  getOptionList,
  companySelected,
  companyId

}) => {
  const [searchTerm, setSearchTerm] = useState<string>(companySelected || '');
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const handleCatchValue = (value: string) => {
    if (value !== `${label}`) {
      setCompanySelected(value);
      setSearchTerm(value);
    } else {
      setCompanySelected("");
      setSearchTerm('');
    }
    setShowOptions(false);
  };
  
  const handleGetList = () => {
    getOptionList();
  };

  const filteredOptions = optionList ? Object.keys(optionList).filter(optionName => 
    optionName.toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];

  return (
    <>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <input
          type="text"
          className={style.select_border}
          placeholder={label}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => {
            handleGetList();
            setShowOptions(true);
          }}
          onBlur={() => setTimeout(() => setShowOptions(false), 200)}
          disabled={!!companyId}
        />
        {showOptions && filteredOptions.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '100%',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            maxHeight: '150px',
            overflowY: 'auto',
            zIndex: 10
          }}>
            {filteredOptions.map((optionName) => (
              <div
                key={optionName}
                onClick={() => handleCatchValue(optionName)}
                style={{
                  padding: '2px 8px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  fontSize: '14px',
                  lineHeight: '1.1',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                {optionName}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
